/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_No_ExpiryInputs */

const en_share_no_expiry = /** @type {(inputs: Share_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`never expires`)
};

const de_share_no_expiry = /** @type {(inputs: Share_No_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`läuft nicht ab`)
};

/**
* | output |
* | --- |
* | "never expires" |
*
* @param {Share_No_ExpiryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_no_expiry = /** @type {((inputs?: Share_No_ExpiryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_No_ExpiryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_no_expiry(inputs)
	return en_share_no_expiry(inputs)
});